import HTTP from '../HTTP';

export default {
    login(credentials) {
        return HTTP.post('auth/login', credentials);
    },
    register(data) {
        return HTTP.post('auth/register', data);
    },
    info() {
        return HTTP.get('user');
    },
    logout() {
        return HTTP.get('user/logout');
    },
    users(query) {
        return HTTP.get('users', {
            params: query
        });
    },
    usersList() {
        return HTTP.get('user/list');
    },
    update(data) {
        return HTTP.put('user/settings', { ...data });
    },
    adminEditUserBaseData(user) {
        const { id, name, password } = user;
        return HTTP.put(`/user/${id}/edit`, {
            name,
            password
        });
    },
    adminEditAcceptUser(userId) {
        return HTTP.put(`/user/${userId}/accept`);
    },
    adminEditUnblockLoginUser(userId) {
        return HTTP.put(`/user/${userId}/unblock-login`);
    },
    adminEditUserAttachCompany(attachCompanyData) {
        const { userId, company_ids } = attachCompanyData;
        return HTTP.put(`/user/${userId}/attach`, {
            company_ids
        });
    },
    getUserAttachedCompany(userId) {
        return HTTP.get(`user/${userId}/companies`);
    }
};